import React, { useEffect, useState } from "react";
import { ArrowUpIcon } from "lucide-react";
import styles from "./FloatingButtons.module.css";
import { smoothScrollTo, cancelSmoothScroll } from "../utils/smoothScrollTo";

const BackToTop: React.FC<{ className?: string }> = ({ className }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > 500);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.blur();

    const reduce =
      typeof document !== "undefined" &&
      document.documentElement.hasAttribute("data-motion-reduce");

    cancelSmoothScroll();
    if (reduce) {
      window.scrollTo(0, 0);
      return;
    }

    smoothScrollTo(0, 900);
  };

  return (
    <button
      type="button"
      className={`${styles.floatingButton} ${className} ${
        !isVisible ? styles.hidden : ""
      }`}
      onClick={handleClick}
      aria-label="Nach oben"
      title="Nach oben"
    >
      <ArrowUpIcon size={22} aria-hidden="true" focusable="false" />
    </button>
  );
};

export default BackToTop;
